import { useEffect, useState } from 'react';

const isPortrait = () => window.innerHeight > window.innerWidth;

/** True while the viewport is taller than wide; updates on resize / rotation. */
export default function usePortrait() {
  const [portrait, setPortrait] = useState(isPortrait());
  useEffect(() => {
    const onChange = () => setPortrait(isPortrait());
    window.addEventListener('resize', onChange);
    window.addEventListener('orientationchange', onChange);
    return () => {
      window.removeEventListener('resize', onChange);
      window.removeEventListener('orientationchange', onChange);
    };
  }, []);
  return portrait;
}
